import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';
import { captureException } from '@sentry/react';

import envConfig, { buildRuntimeConfig } from '../../index';
import { useGetCommandCenterAppConfigQuery } from '@occc/graphql';

import { ConfigContextValue } from '../config-context.types';

export const useCreateConfigContext = (): ConfigContextValue => {
  const handleLoadingError = (error: ApolloError) => {
    captureException(error, {
      level: 'fatal',
    });
  };

  const { data, error, refetch } = useGetCommandCenterAppConfigQuery({
    // `network-only` because we use it in context
    fetchPolicy: 'network-only',
    onError: handleLoadingError,
  });

  const config = useMemo(() => {
    if (error || !data?.appConfig) {
      return null;
    }

    return buildRuntimeConfig({
      remoteConfig: data.appConfig,
      envConfig,
    });
  }, [data?.appConfig]);

  return useMemo(
    () => ({
      error,
      loaded: !!(config || error),
      config,
      refetch,
    }),
    [config, error, refetch],
  );
};
